// (c) chaehongee. Confidential and proprietary.

import type { RootState } from '../store'
import { selectActiveSessionId } from './sessionSelectors'
import type { ChatMessage, InteractiveState } from '../../components/Backstage/utils/types'
import type { ContextUsage } from '../slices/chatSlice'

const EMPTY_CHAT_MESSAGES: ChatMessage[] = []

export function selectChatMessagesBySessionId(
    state: RootState,
    sessionId: string
): ChatMessage[] {
    return state.chat.bySessionId[sessionId]?.messages ?? EMPTY_CHAT_MESSAGES
}

export function selectChatInputBySessionId(state: RootState, sessionId: string): string {
    return state.chat.bySessionId[sessionId]?.input ?? ''
}

export function selectIsProcessingBySessionId(
    state: RootState,
    sessionId: string
): boolean {
    return Boolean(state.chat.bySessionId[sessionId]?.isProcessing)
}

export function selectInteractiveBySessionId(
    state: RootState,
    sessionId: string
): InteractiveState {
    return state.chat.bySessionId[sessionId]?.interactive ?? null
}

export function selectContextUsageBySessionId(
    state: RootState,
    sessionId: string
): ContextUsage | null {
    return state.chat.bySessionId[sessionId]?.contextUsage ?? null
}

export function selectActiveChatMessages(state: RootState): ChatMessage[] {
    const id = selectActiveSessionId(state)
    return id ? selectChatMessagesBySessionId(state, id) : EMPTY_CHAT_MESSAGES
}

export function selectActiveChatInput(state: RootState): string {
    const id = selectActiveSessionId(state)
    return id ? selectChatInputBySessionId(state, id) : ''
}

export function selectIsActiveChatProcessing(state: RootState): boolean {
    const id = selectActiveSessionId(state)
    return id ? selectIsProcessingBySessionId(state, id) : false
}

export function selectActiveInteractive(state: RootState): InteractiveState {
    const id = selectActiveSessionId(state)
    return id ? selectInteractiveBySessionId(state, id) : null
}

export function selectActiveContextUsage(state: RootState): ContextUsage | null {
    const id = selectActiveSessionId(state)
    return id ? selectContextUsageBySessionId(state, id) : null
}

